/** Shared TOEIC practice labels for beginner-friendly UI (VI + EN terms). */

export { DEFAULT_TOEIC_YEAR } from './defaultYear';

export type PartMeta = {
  part: number;
  en: string;
  vi: string;
  countLabel: string;
  section: 'listening' | 'reading';
  tip: string;
};

export const PARTS: PartMeta[] = [
  {
    part: 1,
    en: 'Photographs',
    vi: 'Mô tả tranh',
    countLabel: '6 câu',
    section: 'listening',
    tip: 'Nghe và chọn mô tả đúng với bức tranh. Có thể nghe lại trước khi nộp bài.',
  },
  {
    part: 2,
    en: 'Question–Response',
    vi: 'Hỏi đáp',
    countLabel: '25 câu',
    section: 'listening',
    tip: 'Nghe câu hỏi rồi chọn câu trả lời phù hợp nhất trong 3 lựa chọn.',
  },
  {
    part: 3,
    en: 'Conversations',
    vi: 'Hội thoại',
    countLabel: '39 câu · 13 đoạn',
    section: 'listening',
    tip: 'Mỗi hội thoại có 3 câu hỏi. Đọc trước câu hỏi nếu cần, rồi nghe và chọn đáp án.',
  },
  {
    part: 4,
    en: 'Short Talks',
    vi: 'Bài nói ngắn',
    countLabel: '30 câu · 10 bài',
    section: 'listening',
    tip: 'Nghe bài nói ngắn (thông báo, hướng dẫn…) và trả lời 3 câu cho mỗi bài.',
  },
  {
    part: 5,
    en: 'Incomplete Sentences',
    vi: 'Hoàn thành câu',
    countLabel: '30 câu',
    section: 'reading',
    tip: 'Chọn từ/cụm từ đúng để hoàn thành câu. Tập trung ngữ pháp và từ vựng.',
  },
  {
    part: 6,
    en: 'Text Completion',
    vi: 'Hoàn thành đoạn văn',
    countLabel: '16 câu · 4 đoạn',
    section: 'reading',
    tip: 'Đọc đoạn văn và điền chỗ trống. Chú ý mạch ý và ngữ cảnh.',
  },
  {
    part: 7,
    en: 'Reading Comprehension',
    vi: 'Đọc hiểu',
    countLabel: '54 câu · 15 bài',
    section: 'reading',
    tip: 'Đọc email, thông báo, bài báo… rồi trả lời câu hỏi. Đọc câu hỏi trước giúp tiết kiệm thời gian.',
  },
];

export function getPartMeta(partNumber: number | string | undefined): PartMeta | undefined {
  const n = Number(partNumber);
  return PARTS.find((p) => p.part === n);
}

export const HOW_TO_STEPS = [
  'Chọn một bài Test (Test 1–10).',
  'Chọn Part muốn ôn (Listening hoặc Reading).',
  'Làm lần lượt các câu, rồi bấm Nộp bài để xem điểm và đáp án.',
];
